export enum SubscriptionStatus {
  Disconnected = "Disconnected",
  Active = "Active",
  AwaitingPayment = "Awaiting Payment",
  Pending = "Pending",
  RequestDisconnect = "Request Disconnect",
  DisconnectPendingReconnect = "Disconnect Pending Reconnect"
}
